module.exports = __webpack_public_path__ + "static/media/20ECE12.e97608a6.jpg";